import { render, staticRenderFns } from "./UploadImage.vue?vue&type=template&id=97b2f186&scoped=true&"
import script from "./UploadImage.vue?vue&type=script&lang=js&"
export * from "./UploadImage.vue?vue&type=script&lang=js&"
import style0 from "./UploadImage.vue?vue&type=style&index=0&id=97b2f186&prod&lang=less&"
import style1 from "./UploadImage.vue?vue&type=style&index=1&id=97b2f186&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b2f186",
  null
  
)

export default component.exports